module.exports = __webpack_public_path__ + "img/banner0309_1.d4edbf88.jpg";